import { Partner } from '@m4a3/api-client';
import { orderfulApi } from '../services/api-instances';


interface FileURL {
  fileUrl: string;
}

export const getPartners = (): Promise<Partner[]> => {
  return orderfulApi.getAllPartners()
};

export const addPartner = (partner: Partner): Promise<Partner> => {
  return orderfulApi.createPartner(partner)
};

export const uploadImage = (image: FormData, fileNamePrefix: string): Promise<FileURL> => {
  return orderfulApi.uploadStoreImage(image, {fileNamePrefix});
}
